import classes from './Examples.module.css';

const Examples = () => {
  return (
    <aside className={classes.examplesContainer}>
      <p className={classes.title}>Ejemplos</p>
      <div className={classes.exampleTypes}>
        <figure className={classes.exampleImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/cursosBautismo.jpg"
            alt=""
            className={classes.img}
          />
        </figure>
        <p className={classes.subtitleSection}>
          Cursos para bautismo, confirmación y primera comunión
        </p>
        <p className={classes.secondaryText}>
          La Arquidiócesis de Monterrey facilita la preparación de
          papás y padrinos a través de cursos en línea de alta
          calidad siempre disponibles en su propia Academia Mayahii.
        </p>
      </div>
      <div className={classes.exampleTypes}>
        <figure className={classes.exampleImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/carreraprofesionalDocente.png"
            alt=""
            className={classes.img}
          />
        </figure>
        <p className={classes.subtitleSection}>
          Formación para la carrera profesional docente
        </p>
        <p className={classes.secondaryText}>
          Instancias formadoras con reconocimiento oficial de la SEP
          ofrecen cursos y diplomados con validez oficial para el
          desarrollo profesional docente en su propia Academia
          Mayahii.
        </p>
      </div>
      <div className={classes.exampleTypes}>
        <figure className={classes.exampleImg}>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/conoceEduStore.png"
            alt=""
            className={classes.img}
          />
        </figure>
        <p className={classes.subtitleSection}>Conoce la EduStore</p>
        <p className={classes.secondaryText}>
          Con usuarios de todo el mundo, la EduStore te ofrece la
          oportunidad de aumentar la exposición de tus cursos al
          mercado internacional, para así incrementar tus ventas y
          tus ingresos.
        </p>
      </div>
    </aside>
  );
};

export default Examples;
